import { render, staticRenderFns } from "./MyOrganizationConfig.vue?vue&type=template&id=45b5efd0"
import script from "./MyOrganizationConfig.vue?vue&type=script&lang=js"
export * from "./MyOrganizationConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports